const CollapseGroupSelectors = {
  getCollapseGroups(store) {
    return store.collapseGroup;
  },
};

export { CollapseGroupSelectors };
